module.exports = __webpack_public_path__ + "static/media/china.7ece23cc.PNG";